export const PRODUCT_BASE_QUERY_KEY = 'product-base';
export const TAILORED_QUERY_KEY = 'product-tailored';
